//var mapSetPreferredCentre;
//var mapCurrentPreferredCentre;

// var localmaps = [];
// var map_locations = [];
// var local_markers = [];
// var defaultLat = 56.846850;
// var defaultLong = -3.959389;
// var postcode = '';
// var zoom = 8;
// var map;
// var markers;
// var mapFilters = [];
// const SCOTLAND_BOUNDS = {
// 	north: 59.3826060,
// 	south: 53.4672880,
// 	west: -7.74388799,
// 	east: 1.814217,
//   };



(function($) {

	// function new_map(el, pointCenter=false, defaultZoom=zoom) {

	// 	markers = el.find('.marker');
	// 	var args = {
	// 		zoom: defaultZoom,
	// 		mapTypeId: google.maps.MapTypeId.ROADMAP,
	// 		disableDefaultUI: true,
	// 		restriction: {
	// 			latLngBounds: SCOTLAND_BOUNDS,
	// 			strictBounds: false,
	// 		},
	// 		styles: [
	// 			{
	// 				"featureType": "all",
	// 					"elementType": "all",
	// 					"stylers": [
	// 						{
	// 							"invert_lightness": true
	// 						},
	// 						{
	// 							"saturation": 10
	// 						},
	// 						{
	// 							"lightness": 30
	// 						},
	// 						{
	// 							"gamma": 0.5
	// 						},
	// 						{
	// 							"hue": "#435158"
	// 						}
	// 					]
	// 			},

	// 			{
	// 				"featureType": "administrative",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"color": "#89c0eb"
	// 					},
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "landscape",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"color": "#023f58"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "landscape.man_made",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"color": "#1d2d4d"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "water",
	// 				"elementType": "geometry.fill",
	// 				"stylers": [
	// 					{
	// 						"color": "#0e1726"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road",
	// 				"elementType": "labels",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road",
	// 				"elementType": "geometry.fill",
	// 				"stylers": [
	// 					{
	// 						"color": "#0e1726"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.highway",
	// 				"elementType": "geometry.fill",
	// 				"stylers": [
	// 					{
	// 						"color": "#2b6775"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.arterial",
	// 				"elementType": "geometry.fill",
	// 				"stylers": [
	// 					{
	// 						"color": "#314a7d"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "all",
	// 				"elementType": "labels.text.fill",
	// 				"stylers": [{ color: "#6d9a97" }],

	// 			  },

	// 			{
	// 				featureType: 'poi',
	// 				stylers: [{visibility: 'off'}]
	// 			},
	// 			{
	// 				featureType: 'transit',
	// 				elementType: 'labels.icon',
	// 				stylers: [{visibility: 'off'}]
	// 			}
	// 		],
	// 	}

	// 	if(pointCenter){
	// 		args.center=  new google.maps.LatLng(defaultLat, defaultLong);
	// 	}

	// 	map = new google.maps.Map( el[0], args);
	// 	map.markers = [];
	// 	markers.each(function() {
	// 		add_marker($(this), map);
	// 	});

	// 	if(!pointCenter){
	// 		center_map(map, defaultZoom);
	// 	}

	// 	return map;
	// }

	// function add_marker($marker, newmap) {

	// 	var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

	// 	var icon = {
	// 		url: $marker.attr('data-icon')
	// 	}

	// 	var marker = new google.maps.Marker({
	// 		position: latlng,
	// 		map: newmap,
	// 		icon: icon,
	// 		service: $marker.attr('data-service'),
	// 		garageid: $marker.attr('data-garageid'),
	// 	});

	// 	// if marker contains HTML, add it to an infoWindow
	// 	//if ($marker.html()) {
	// 		// marker.infowindow = new google.maps.InfoWindow({
	// 		// 	content		: $marker.html()
	// 		// });

	// 		// google.maps.event.addListener(marker, 'click', function() {

	// 		// 	console.log(marker);

	// 		// 	for (var i=0; i<newmap.markers.length; i++) {
	// 		// 		newmap.markers[i].infowindow.close();
	// 		// 	}


	// 		// 	marker.infowindow.open(newmap, marker);
	// 		// });
	// 	//}
	// 	let garagid = $marker.attr('data-garageid');
	// 	let garage_position =  marker.getPosition();
	// 	local_markers[garagid] =  garage_position ;


	// 	// marker.addListener("click", () => {
	// 	// 	map.setZoom(8);
	// 	// 	map.setCenter(marker.getPosition());
	// 	// 	console.log(marker);
	// 	//   });

	// 	newmap.markers.push(marker);

	// 	// if ($marker.attr('data-region')) {
	// 	// 	map_locations.push($marker.attr('data-region'));
	// 	// }
	// }

	// function center_map(newmap, zoom) {
	// 	var bounds = new google.maps.LatLngBounds();

	// 	$.each(newmap.markers, function(i, marker) {
	// 		if (marker.visible) {
	// 			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

	// 			bounds.extend(latlng);
	// 		}
	// 	});

	// 	if (newmap.markers.length == 1) {
	// 		newmap.setCenter(bounds.getCenter());
	// 		newmap.setZoom(zoom);
	// 	} else {
	// 		newmap.fitBounds(bounds);
	// 	}
	// }

	// function map_center_when_filtering() {
	// 	console.log('centermap called');
	// 	//var bounds = //map.getBounds(); // google.maps.LatLngBounds();
	// 	var bounds = new google.maps.LatLngBounds();

	// 	$.each(map.markers, function(i, marker) {
	// 		if (marker.visible) {
	// 			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

	// 			bounds.extend(latlng);
	// 		}
	// 	});

	// 	map.fitBounds(bounds);
	// 	//map.setCenter(bounds.getCenter());

	// }

	// function show_locations(region) {
	// 	for (var i=0; i<map_locations.length; i++) {
	// 		if (map_locations[i] == region) {
	// 			map.markers[i].setVisible(true);
	// 		}
	// 	}
	// }

	// function hide_locations(region) {
	// 	for (var i=0; i<map_locations.length; i++) {
	// 		if (map_locations[i] == region) {
	// 			//map.markers[i].infowindow.close();
	// 			map.markers[i].setVisible(false);
	// 		}
	// 	}
	// }

	//var header_position = $('header').offset().top;

	// function header_scrolled(scroll) {
	// 	if (scroll > header_position) {
	// 		$('body').addClass('scrolled');
	// 		$('header').addClass('scrolled');
	// 	} else {
	// 		$('body').removeClass('scrolled');
	// 		$('header').removeClass('scrolled');
	// 	}

	// 	var footer_position = $('#footer-section').offset().top;
	// 	var scroll_bottom = scroll + $(window).innerHeight();
	// 	if (scroll_bottom > footer_position) {
	// 		$('body').addClass('scrolled-footer');
	// 	} else {
	// 		$('body').removeClass('scrolled-footer');
	// 	}
	// }

	// mapSetPreferredCentre = function(location) {
	// 	if (location) {
	// 		var data = {
	// 			'action': 'locations',
	// 			'location_action': 'set_preferred_location',
	// 			'location_id': location
	// 		};

	// 		$.post({
	// 			'url': tca_local.ajax_url,
	// 			'data': data,
	// 			'success': function(response) {
	// 				var response = $.parseJSON(response);
	// 				if(response.success) {
	// 					setPreferedCentre(location, response.data);
	// 				}
	// 			}
	// 		});
	// 	}
	// }

	// function setPreferedCentre(location, data) {
	// 	data = typeof data !== 'undefined' ? data : false;

	// 	mapCurrentPreferredCentre = parseInt(location);
	// 	$('.preferred_location').each(function() {
	// 		$(this).removeClass('preferred_location');
	// 		$('.set-location .text:not(.short)', this).html('Set as your preferred centre?');
	// 		$('.set-location .text.short', this).html('Set as preferred');
	// 		$('.set-location .fa', this).removeClass('fa-heart').addClass('fa-heart-o');
	// 		if($(this).hasClass('.marker-popup')) {
	// 			$(this).closest('.gm-style-iw-d').next().removeClass('preferred_location');
	// 		}
	// 	});

	// 	$('.preferred-location-'+location).addClass('preferred_location');
	// 	$('.set-location[data-location="'+location+'"] .text:not(.short)').html('This is your preferred centre');
	// 	$('.set-location[data-location="'+location+'"] .text.short').html('Preferred centre');
	// 	$('.set-location[data-location="'+location+'"] .fa').removeClass('fa-heart-o').addClass('fa-heart');
	// 	$('#map-location-'+location+'-popup').closest('.gm-style-iw-d').next().addClass('preferred_location');

	// 	if (data) {
	// 		$('.preferred-centre-details').removeClass('d-none');
	// 		$('.no-preferred-centre-message').remove();
	// 		$('.preferred-centre-link').attr('href', data.link);
	// 		$('.preferred-centre-name').text(data.name);
	// 		var address2 = data.address2 !== false ? ' ' + data.address2 + ',' : '';
	// 		var address = data.address1 + ',' + address2 + '<br>' + data.town + ' ' + data.postcode;
	// 		$('.preferred-centre-address').html(address);
	// 		var phone = data.phone.replace(/\s/g, '');
	// 		$('.preferred-centre-tel').attr('href', 'tel:' + phone).text(data.phone);
	// 		$('.preferred-centre-email').attr('href', 'mailto:' + data.email).text(data.email);
	// 		$('.preferred-centre-manager').text(data.manager);
	// 		$('.preferred-centre-opening-hours').html(data.opening_hours);
	// 		$('.gform_wrapper .service-locations .gfield_select').val(data.slug);
	// 	}
	// }

	/*
	 *  document ready
	 *
	 *  This function will render each map when the document is ready (page has loaded)
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	5.0.0
	 *
	 *  @param	n/a
	 *  @return	n/a
	 */
	// global var


	$(document).ready(function() {


		//var map_section_map_container = $('#show-map');

		// $('.map').not('.lazy').each(function() {
		// 	map = new_map($(this));
		// });

		// $('#map_postcode_search').submit(function(e) {
		// 	e.preventDefault()
		// 	var postcode = $('#map_postcode').val();
		// 	var filter = $('#map_postcode').data('filter');
		// 	if (postcode) {
		// 		$.ajax({
		// 			type: 'POST',
		// 			url: tca_local.ajax_url,
		// 			data: {
		// 				'action': 'locations',
		// 				'location_action': 'get_local',
		// 				'local_postcode': postcode,
		// 				'filter': filter
		// 			},
		// 			success: function (response) {
		// 				var response = $.parseJSON(response);
		// 				if(response.success && response.data) {
		// 					$('#map-local-centre-panel').html(response.data)
		// 					$('#map-section').removeClass('show-map').addClass('show-local')
		// 					$('.local-map').each(function() {
		// 						localmaps.push(new_map($(this), false));
		// 					});

		// 					$('#map-section .map-filter.active').trigger('click')

		// 					var contentHeight = $('#map-section .map-content').height()
		// 					var localHeight = $('#map-local-centre-panel>.row').height()
		// 					if(contentHeight < localHeight + 56) {
		// 						$('#map-section .map-content').css('min-height', localHeight + 56)
		// 					}
		// 				}
		// 			}
		// 		});
		// 	} else {
		// 		$(this).after('<div class="error">Please enter your postcode above to find nearby centres</div>');
		// 	}
		// });

		// $('.garage-details').ready(function(){
		// 	new_map($('#single-garage-map'), false, 13);
		// });

		// $('#mapModal').on('show.bs.modal', function (event) {
		// 	postcode = $('.v-pageHead--titlebar-content').find('.single-input').val();
		// 	var modal = $(this);
		// 	modal.find('#postcode').val(postcode);
		// 	//loadGarages(postcode);
		// });


		// function loadGarages(postcode=''){
		// 	//postcode has no effect for now

		// 	let postData = {
		// 		"action": "tca_garages",
		// 		"post_action": "get_garages_for_map",
		// 		"filters": { 'postcode': postcode }
		// 	}

		// 	let request = $.post( ajaxurl, postData );
		// 	request.done(function(response){
		// 		const result = JSON.parse(response);
		// 		if(result.success && result.data.garages){
		// 			displayGarages(result.data);
		// 		}
		// 	});
		// }

		// function displayGarages(data){
		// 	let string = '';
		// 	let list = '';
		// 	let quantity = 0;
		// 	let zoom = 7;
		// 	let center = false;
		// 	if(data.garages){

		// 		data.garages.forEach((el, i) => {

		// 			string += '<div class="marker garage'+el.ID+'" data-lat="'+el.lat+'" data-lng="'+el.long+'" data-icon="'+data.icon+'" data-garageid="garage'+el.ID+'" data-service="'+el.service+'" data-region="'+el.town+'" data-link="/?name='+el.name+'&town='+el.town+'&postcode='+el.postcode+'&id='+el.ID+'"></div>';

		// 			list += '<div class="item garage'+el.ID+'" data-garageid="garage'+el.ID+'" data-region="'+el.town+'">';
		// 				list += '<div class="info"><a href="/?name='+el.name+'&town='+el.town+'&postcode='+el.postcode+'&id='+el.ID+'"><span class="title">'+el.name+'</span><span class="address">'+el.address+'</span><span class="city">'+el.town+',<span class="postcode"> '+el.postcode+'</span></span></a></div>';
		// 				list += '<div class="contact"><div class="info-link"><a href="tel:'+el.phone+'" class="call"></a><a href="mailto:'+el.email+'" class="email"></a></div><div class="details"><a href="/?name='+el.name+'&town='+el.town+'&postcode='+el.postcode+'&id='+el.ID+'" class="details-link">Details</a></div></div>';
		// 			list += '</div>';
		// 			quantity++;
		// 		});

		// 		zoom = data.zoom;
		// 		center = false;

		// 	}else{

		// 		string ='<div class="marker" data-lat="56.846850" data-lng="-3.959389" data-icon="" data-region="edinburgh">	</div>';
		// 		list = '<div class="item"><div class="info"><span>Oops ! Nothing found .</span></div></div>';
		// 	}

		// 	$('#show-map').html(string);
		// 	$('#show-garages').html(list);
		// 	$('.search-title').html(quantity+' service point found');

		// 	localmaps.push( new_map($('#show-map'), center, zoom));

		// 	//loadLazyMap(map_section_map_container);
		// }

		// $('#mapModal').on('change', '#postcode', function () {

		// 	let postData = {
		// 		"action": "tca_garages",
		// 		"post_action": "get_garages_for_map",
		// 		"filters": { 'postcode': $('#postcode').val() }
		// 	}

		// 	let request = $.post( ajaxurl, postData );
		// 	request.done(function(response){

		// 		const result = JSON.parse(response);
		// 		console.log(result.data);
		// 		if(result.success && result.data.garages){
		// 			displayGarages(result.data);
		// 		}
		// 	});
		// });

		// $('#show-garages').on('mouseenter mouseout', '.item', function(){
		// 	let garageid = $(this).data('garageid');
		// 	let marker_position = local_markers[garageid];

		// 	map.markers.forEach( (marker, index) => {
		// 		if(marker_position == marker.getPosition()){
		// 			marker.setIcon(asset_img_url+'/icon-material-location-white.png');
		// 		}else{
		// 			marker.setIcon(asset_img_url+'/icon-material-location-yellow.png');
		// 		}
		// 	})

		// });


		// $('#map-filter input[type=checkbox]').on('change', function(){
		// 	let selectedval = $(this).val();

		// 	if($(this).is(':checked')){
		// 		mapFilters.push(selectedval);
		// 	}else{
		// 		const index = mapFilters.indexOf(selectedval);
		// 		if (index > -1) {
		// 			mapFilters.splice(index, 1);
		// 		}
		// 	}

		// 	filterMapByService();
		// });

		// function filterMapByService(){

		// 	//console.log(local_markers);

		// 	//local_markers['garage826'].setMap(map);

		// 	// local_markers.forEach( (marker, index) => {
		// 	// 	marker.setMap(map);
		// 	// 	console.log(marker);
		// 	// })

		// 	console.log(mapFilters);
		// 	//console.log(local_markers);
		// 	if(mapFilters.length){

		// 		map.markers.forEach( (marker, index) => {
		// 			//console.log(marker);
		// 			let services = marker.service.split(',');
		// 			var filtered_service = services.filter(function (el) {
		// 				return el != '';
		// 			});
		// 			console.log(filtered_service);
		// 			let found = false;
		// 			let showInMap = false;
		// 			mapFilters.forEach((element, index) => {
		// 				found = filtered_service.includes(element);
		// 				if(found){
		// 					showInMap = true;
		// 				}else{
		// 					showInMap = false;
		// 				}
		// 			})

		// 			//console.log(showInMap);
		// 			if(!showInMap){
		// 				marker.setMap(null);
		// 				$('#show-garages .'+marker.garageid).slideUp();
		// 			}else{
		// 				marker.setMap(map);
		// 				$('#show-garages .'+marker.garageid).slideDown();
		// 			}
		// 		})

		// 	}else{

		// 		map.markers.forEach( (marker, index) => {
		// 			marker.setMap(map);
		// 			$('#show-garages .item').slideDown();
		// 		})
		// 	}

		// 	map_center_when_filtering();



		// }


		// $('#map-filter').on('click', '.title', function(){
		// 	console.log(map.getBounds());
		// });


		// $('#filter-select').on('change', function() {
		// 	var value = $(this).val();
		// 	$('.filter-results .filter-item').filter(function() {
		// 		if (value) {
		// 			$(this).toggle($(this).hasClass(value));
		// 		} else {
		// 			$(this).show();
		// 		}
		// 	});
		// });

		// $('.set-location').click(function(event) {
		// 	event.preventDefault();

		// 	var location_id = $(this).data('location');

		// 	if (location_id != '') {
		// 		var data = {
		// 			'action': 'locations',
		// 			'location_action': 'set_preferred_location',
		// 			'location_id': location_id
		// 		};

		// 		$.post({
		// 			'url': tca_local.ajax_url,
		// 			'data': data,
		// 			'success': function(response) {
		// 				var response = $.parseJSON(response);
		// 				if(response.success) {
		// 					setPreferedCentre(location_id, response.data);
		// 				}
		// 			}
		// 		});
		// 	}
		// });

		// $('#map-section .map-filter').click(function(e) {
		// 	var screenwidth =  window.outerWidth;
		// 	if (screenwidth >= 992) {
		// 		var filter = '';
		// 		var isActive = $(this).hasClass('active');
		// 		var region = $(this).data('region');

		// 		loadLazyMap(map_section_map_container);

		// 		if (!$(this).hasClass('deselected')) {
		// 			$('.map-filter').each(function() {
		// 				var thisRegion = $(this).data('region');
		// 				if (region != thisRegion) {
		// 					$(this).removeClass('deselected');
		// 					hide_locations(thisRegion);
		// 				} else {
		// 					$(this).addClass('deselected');
		// 					show_locations(thisRegion);
		// 				}
		// 			});
		// 		} else {
		// 			$('.map-filter').each(function() {
		// 				var thisRegion = $(this).data('region');
		// 				$(this).removeClass('deselected');
		// 				show_locations(thisRegion);
		// 			});
		// 		}

		// 		center_map(map);

		// 		$('#map-section .map-filter').removeClass('active');
		// 		if (!isActive) {
		// 			filter = $(this).data('region');
		// 			$(this).addClass('active');
		// 		}

		// 		if (filter) {
		// 			$('.all-centres', '#map-section').addClass('filtered');
		// 			$('.map-location-col', '#map-section').hide();
		// 			$('.map-location-col[data-region=' + filter + ']', '#map-section').show();

		// 			$('#map-section').removeClass('show-local');
		// 		} else {
		// 			$('.all-centres', '#map-section').removeClass('filtered');
		// 			$('.map-location-col', '#map-section').show();
		// 		}
		// 	} else {
		// 		$('#map-section .nearest-mobile-accordion').addClass('closed');
		// 		if (!$(this).hasClass('accordion-open')) {
		// 			$('#map-section .map-filter').removeClass('accordion-open');
		// 			var region = $(this).data('region');
		// 			$('#nearest-region-' + region).removeClass('closed');
		// 		}
		// 		$(this).toggleClass('accordion-open');
		// 	}
		// })

		// $('#map-section .map-toggle').click(function(e) {
		// 	if ($('#map-section').hasClass('show-local') || $('#map-section').hasClass('show-map')) {
		// 		$('#map-section .map-content').css('min-height', '');
		// 		$('#map-section').removeClass('show-local').removeClass('show-map');
		// 	} else {
		// 		loadLazyMap(map_section_map_container);
		// 		$('#map-section').addClass('show-map');
		// 	}
		// })

		// function loadLazyMap(lazy_map) {
		// 	if (!lazy_map.hasClass('map-loaded')) {
		// 		map = new_map(lazy_map);
		// 		map.addListener('tilesloaded', function() {
		// 			lazy_map.addClass('map-loaded');
		// 		});
		// 	}
		// }

	//	mapCurrentPreferredCentre = parseInt($('.preferred_location .set-location').first().data('location'));




	});


})(jQuery);


//# sourceMappingURL=sourcemaps/main.js.map